import { Web } from "../Pages/Web";
import { GoogleMap } from "../components/organism/GoogleMap";
import { WebPosts } from "../components/organism/WebPosts";
import { WebReviews } from "../components/organism/WebReviews";
import { WidgetsContact } from "../components/organism/widgets/WidgetsContact";
import { WidgetsPost } from "../components/organism/widgets/WidgetsPost";
import { WidgetsReplyReviews } from "../components/organism/widgets/WidgetsReplyReviews";
import { WidgetsReviews } from "../components/organism/widgets/WidgetsReviews";
import { MaxcolchonWidgetsReviews } from "../components/organism/widgets/maxcolchon/MaxcolchonWidgetsReviews";

export const routes = [	
	{
		path: '/web/:id',
		component: Web,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webPosts/:id',
		component: WebPosts,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webReviews/:id',
		component: WebReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/widgets/reviews/:id',
		component: WidgetsReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/maxcolchon/widgets/reviews/:id',
		component: MaxcolchonWidgetsReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/widgets/contact/:id',
		component: WidgetsContact,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/widgets/posts/:id',
		component: WidgetsPost,
		viewHeader: false,
		isAuthenticated: false
	},
	{// White Label
		path: '/widgets/reply-reviews/:id',
		component: WidgetsReplyReviews,
		viewHeader: false,
		isAuthenticated: false
	},
	{
		path: '/webMap/:id',
		component: GoogleMap,
		viewHeader: false,
		isAuthenticated: false
	}
	,
	// {
	// 	path: '/error403',
	// 	component: Error403,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
	// ,
	// {
	// 	path: '/error404',
	// 	component: Error404,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
	// ,
	// {
	// 	path: '/error500',
	// 	component: Error500,
	// 	viewHeader: false,
	// 	isAuthenticated: true
	// }
]